import axios, { AxiosInstance } from 'axios'
import { getConfig } from '../config'
import { setupResponseInterceptor } from './axios-interceptor'

const config = await getConfig()

export enum ApiInstanceKeys {
  AUTHORIZATION = 'AUTHORIZATION',
  ONBOARDING = 'ONBOARDING',
  CUSTOMER_LIFE_CYCLE = 'CUSTOMER_LIFE_CYCLE',
  PAYAUT = 'PAYAUT',
  CHARGER_MANAGEMENT = 'CHARGER_MANAGEMENT',
  DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT',
  CONTACT_FORM = 'CONTACT_FORM',
  ASSET_MANAGEMENT = 'ASSET_MANAGEMENT',
}

// Create all API instances
export const API_INSTANCES: Record<ApiInstanceKeys, AxiosInstance> = {
  [ApiInstanceKeys.AUTHORIZATION]: axios.create({
    baseURL: config.authorizationServiceBaseUrl,
    timeout: 60000,
  }),
  [ApiInstanceKeys.ONBOARDING]: axios.create({
    baseURL: config.onboardingServiceBaseURL,
    timeout: 60000,
  }),
  [ApiInstanceKeys.CUSTOMER_LIFE_CYCLE]: axios.create({
    baseURL: config.customerLifeCycleServiceBaseURL,
    timeout: 60000,
  }),
  [ApiInstanceKeys.PAYAUT]: axios.create({
    baseURL: config.payoutServiceBaseURL,
    timeout: 60000,
  }),
  [ApiInstanceKeys.CHARGER_MANAGEMENT]: axios.create({
    baseURL: config.chargerManagementServiceBaseUrl,
    timeout: 60000,
  }),
  [ApiInstanceKeys.DOCUMENT_MANAGEMENT]: axios.create({
    baseURL: config.documentManagementServiceBaseUrl,
    timeout: 60000,
  }),
  [ApiInstanceKeys.CONTACT_FORM]: axios.create({
    baseURL: config.contactFormServiceBaseUrl,
    timeout: 60000,
  }),
  [ApiInstanceKeys.ASSET_MANAGEMENT]: axios.create({
    baseURL: config.assetManagementServiceBaseUrl,
    timeout: 60000,
  }),
}

// Apply response interceptors to all instances except AUTHORIZATION
// (to avoid circular dependency with token refresh)
Object.entries(API_INSTANCES).forEach(([key, instance]) => {
  if (key !== ApiInstanceKeys.AUTHORIZATION) {
    setupResponseInterceptor(instance)
  }
})
